import ClipboardJS from 'clipboard';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';


const social = () => {
	const tippyInstances = tippy('[data-tippy-content]', {
		trigger: 'click',
		theme: 'light',
		appendTo: 'parent',
	});

	// eslint-disable-next-line no-new
	new ClipboardJS('.js-copy-url', {
		text() {
			return window.location;
		},
	});

	const emailClipboard = new ClipboardJS('.js-copy-email', {
		text(target) {
			return target.dataset.email;
		},
	});

	emailClipboard.on('success', () => {
		tippyInstances.forEach((instance) => {
			if (instance.reference.classList.contains('js-copy-email')) {
				instance.setContent('Email copied!');
			}
		});
	});
};


export default social;
